import axios from "axios";
import qs from "qs";
//import ADMIN from "@/api/admin";

// formConfig
const formConfig = {
  transformRequest: [
    function(data, headers) {
      headers["Content-Type"] =
        "application/x-www-form-urlencoded; charset=UTF-8";
      data = qs.stringify(data, { arrayFormat: "indices" });
      return data;
    }
  ]
};

// axios设置
const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true
});

// http response 拦截器
http.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 403) {
      //window.location = ADMIN.LOGIN_URL;
      window.location = "/index.html";
      return;
    }
    return Promise.resolve(error);
  }
);

export default http;
export { formConfig };
